import Loading from './Loading';
import './Loading.scss';

export default Loading;
